import reducer from './reducer';
import * as actions from './action';
import * as constants from './constant';
import * as middleware from './middleware';

export default {
  reducer: reducer,
  action: actions,
  constant: constants,
  middleware: middleware
};



// WEBPACK FOOTER //
// ./src/storeState/persistence/index.js